import { render, staticRenderFns } from "./AssetCategoryForm.vue?vue&type=template&id=08fd05d5&scoped=true"
import script from "./AssetCategoryForm.vue?vue&type=script&lang=js"
export * from "./AssetCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd05d5",
  null
  
)

export default component.exports